import { Blocks } from '@chameleoncreator/creator-app';


export const setBlocksLocalAction = (blocks: Blocks) => {
  return {
    type: 'SET_BLOCKS',
    data: blocks,
  };
};
